import React, { useState } from "react"
import { default as ModalProvider } from "react-modal"
import { useNavigate } from "react-router-dom"
import * as applicationService from "../../../src/services/application-service"
import { JobbinPrimaryButton } from "../primaryButton"
import { FeedbackModalProps } from "./model"
import { useToast } from "../../context/toast"

const FeedbackModal = (props: FeedbackModalProps) => {
  const navigate = useNavigate()
  const { notify } = useToast()
  const [description, setDescription] = useState("")
  const [rating, setRating] = useState(1)
  const [candidateAttended, setCandidateAttended] = useState(true)

  const sendFeedback = async () => {
    if (!props.feedbackData) return

    const feedbackRequest = { ...props.feedbackData }
    feedbackRequest.rating = rating
    feedbackRequest.description = description
    feedbackRequest.candidateAttended = candidateAttended

    const response = await applicationService.sendFeedback(feedbackRequest)

    if (!response.ok) {
      notify("A apărut o eroare. Te rugăm să contactezi suportul.", "error")
    } else {
      notify("Feedback-ul a fost trimis cu succes!", "success")
      navigate("/candidates")
    }
  }

  const ratingItems = [
    { value: 1, label: "Slab", img: "/images/ic-emoji-1.png" },
    { value: 2, label: "Meh", img: "/images/ic-emoji-2.png" },
    { value: 3, label: "Okay", img: "/images/ic-emoji-3.png" },
    { value: 4, label: "Super", img: "/images/ic-emoji-4.png" },
    { value: 5, label: "Fantastic", img: "/images/ic-emoji-5.png" },
  ]

  return (
      <ModalProvider
          appElement={document.getElementById("root")!}
          isOpen={props.isOpen}
          onRequestClose={props.closeModal}
          className="mx-4 my-auto w-full max-w-[720px] rounded-[16px] bg-white outline-none"
          overlayClassName="fixed inset-0 z-50 flex items-center justify-center bg-gray-800/60 p-4"
      >
        <div className="rounded-[16px] bg-white p-5 sm:p-8">
          <p className="text-center text-xl font-bold text-figmaBlack sm:text-2xl">
            Recenzie candidat
          </p>

          <p className="mt-3 text-center text-sm font-bold text-figmaDarkGray sm:text-base">
            Ajută-ne să creștem și lasă o recenzie acestui candidat.
          </p>

          <div className="mx-auto mt-6 max-w-[560px] sm:mt-8">
            <div className="grid grid-cols-3 gap-4 sm:grid-cols-5 sm:gap-6">
              {ratingItems.map((item) => (
                  <button
                      key={item.value}
                      type="button"
                      onClick={() => setRating(item.value)}
                      className="flex flex-col items-center text-center"
                  >
                    <div
                        className={`rounded-full p-3 ${
                            rating === item.value ? "bg-figmaPrimary" : "bg-figmaLightGray"
                        }`}
                    >
                      <img
                          src={item.img}
                          alt={item.label}
                          className="h-10 w-10 sm:h-12 sm:w-12"
                      />
                    </div>
                    <p className="mt-2 text-sm text-figmaBlack">{item.label}</p>
                  </button>
              ))}
            </div>

            <div className="mt-8 flex items-center justify-between rounded-[12px] bg-figmaLightGray px-5 py-4">
              <p className="text-sm font-bold text-figmaBlack sm:text-base">
                Candidatul s-a prezentat?
              </p>
              <button
                type="button"
                onClick={() => setCandidateAttended(!candidateAttended)}
                className={`relative inline-flex h-7 w-12 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ${
                  candidateAttended ? "bg-figmaPrimary" : "bg-gray-300"
                }`}
              >
                <span
                  className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition-transform duration-200 ${
                    candidateAttended ? "translate-x-5" : "translate-x-0"
                  }`}
                />
              </button>
            </div>

            <p className="mt-6 text-sm font-bold text-figmaDarkGray sm:text-base">
              Descrie experiența
            </p>

            <textarea
                className="mt-3 h-[180px] w-full rounded-[12px] bg-figmaLightGray px-5 py-[14px] text-[16px] font-bold sm:h-[220px]"
                onChange={(e) => setDescription((e.target as HTMLTextAreaElement).value)}
                style={{ resize: "none" }}
            />

            <div className="mt-6 sm:mt-8">
              <JobbinPrimaryButton
                  onClickAction={sendFeedback}
                  text="Lasă recenzie"
              />
            </div>
          </div>
        </div>
      </ModalProvider>
  )
}

export default FeedbackModal